import easyfyAxios from '@shared/easyfy.axios';

export interface ISearchData {
  includeArticles: boolean;
  includeBrands: boolean;
  includePages: boolean;
  searchTerm: string;
  partialView?: string;
  subscriptionProductsOnly?: boolean;
}

export const OnSearch = async (data: ISearchData, token: string): Promise<any> => {
  return await easyfyAxios.post('/search', data, token);
};

export const OnGetFocusInData = async (): Promise<any> => {
  return await easyfyAxios.get('/api/searchfocusin');
};
